import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@shadcn-in-nx/ui/tabs";
import { AlertTriangle, BarChart3, BookOpen, TrendingUp, Building2 } from "lucide-react";
import ErrorsTab from "./ErrorsTab";
import OutcomesTab from "./OutcomesTab";
import RulesTab from "./RulesTab";
import AnalyticsTab from "./AnalyticsTab";
import CompanyPatternsTab from "./CompanyPatternsTab";

export default function Intelligence() {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("errors");

    return (
        <div className="p-6 space-y-6">
            <div>
                <h1 className="text-2xl font-bold">
                    {t("admin.intelligence.title")}
                </h1>
                <p className="text-muted-foreground text-sm mt-1">
                    {t("admin.intelligence.description")}
                </p>
            </div>

            <Tabs value={activeTab} onValueChange={setActiveTab}>
                <TabsList>
                    <TabsTrigger value="errors" className="gap-1.5">
                        <AlertTriangle className="h-4 w-4" />
                        {t("admin.intelligence.tabs.errors")}
                    </TabsTrigger>
                    <TabsTrigger value="outcomes" className="gap-1.5">
                        <BarChart3 className="h-4 w-4" />
                        {t("admin.intelligence.tabs.outcomes")}
                    </TabsTrigger>
                    <TabsTrigger value="rules" className="gap-1.5">
                        <BookOpen className="h-4 w-4" />
                        {t("admin.intelligence.tabs.rules")}
                    </TabsTrigger>
                    <TabsTrigger value="companyPatterns" className="gap-1.5">
                        <Building2 className="h-4 w-4" />
                        {t("admin.intelligence.tabs.companyPatterns")}
                    </TabsTrigger>
                    <TabsTrigger value="analytics" className="gap-1.5">
                        <TrendingUp className="h-4 w-4" />
                        {t("admin.intelligence.tabs.analytics")}
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="errors"><ErrorsTab /></TabsContent>
                <TabsContent value="outcomes"><OutcomesTab /></TabsContent>
                <TabsContent value="rules"><RulesTab /></TabsContent>
                <TabsContent value="companyPatterns"><CompanyPatternsTab /></TabsContent>
                <TabsContent value="analytics"><AnalyticsTab /></TabsContent>
            </Tabs>
        </div>
    );
}
